import { render, staticRenderFns } from "./ModellDialog.vue?vue&type=template&id=498e81c6&scoped=true"
import script from "./ModellDialog.vue?vue&type=script&lang=ts"
export * from "./ModellDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498e81c6",
  null
  
)

export default component.exports